import Image from 'next/image'
import styles from './HeroInfoBarLink.module.scss'

interface HeroInfoBarProps {
  imageWidth: number
  imageHeight: number
  imageUrl: string
  anchorText: string
  url: string
}

// HeroInfoBarLink component used in HeroGeneralInfo
// It is used to display emails and phone numbers with an icon next to it
const HeroInfoBarLink = ({ imageHeight, imageWidth, imageUrl, anchorText, url }: HeroInfoBarProps) => (
  <div className={styles['hero-infobar-link']}>
    <Image src={imageUrl} width={imageWidth} height={imageHeight} alt={anchorText} />
    {url ? (
      <a href={url}>
        <p>{anchorText}</p>
      </a>
    ) : (
      <p>{anchorText}</p>
    )}
  </div>
)

export default HeroInfoBarLink
